import React, { useState } from "react";
import GenericTable from "@frameworks/web/components/generic/GenericTable";
import SubscriptionMobileTable from "./SubscriptionMobileTable";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import download from "@frameworks/web/assets/images/Reports/common/download.svg";
import { SubscriptionFeeSubType, } from "@domains/entities/interfaces/Reports/SubscriptionReport/ISubscriptionReport";
import { useSelector } from "react-redux";
import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import { threePaths } from "../DpInterest/DpInterestMobileTable";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import SubscriptionPopup from "./SubscriptionPopup";
const SubscriptionTabData = (props) => {
    var _a, _b, _c, _d;
    const device = DeviceContext();
    const [selectedSubscriptionRate, setSelectedSubscriptionRate] = useState(null);
    const { reducersData: SubsFeedata, commonData: subsFeeCommData } = useSelector((state) => state.SubscriptionReport.SubscriptionFee);
    const [subscriptionPopupShow, setSubscriptionPopupShow] = useState(false);
    const rateBasedColumn = [
        {
            columnName: "Plan Name",
            arrows: false,
            key: "",
            columnClassName: "text-nowrap",
            trCustomFunction: (SubscriptionRate) => {
                return (React.createElement("span", { onClick: () => {
                        setSubscriptionPopupShow(true);
                        setSelectedSubscriptionRate(SubscriptionRate);
                    }, className: "td-schemeName" }, SubscriptionRate.schemeName));
            },
        },
        {
            columnName: "Start Date",
            arrows: false,
            key: "startDate",
            columnClassName: "text-nowrap",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "End Date",
            arrows: false,
            key: "endDate",
            columnClassName: "text-nowrap",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Subscription Fees(Rs)",
            arrows: false,
            key: "chequeAmt",
            columnClassName: "text-nowrap",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Consumed Fees(Rs)",
            arrows: false,
            key: "consumed",
            columnClassName: "text-nowrap",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Balance Fees(Rs)",
            arrows: false,
            key: "balance",
            columnClassName: "text-nowrap",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Plan Status",
            arrows: false,
            key: "status",
            columnClassName: "text-nowrap",
            tdCustomFunction: (key) => {
                return (React.createElement("span", { className: "text-capitalize txt-orange-light", "data-attr": key }, addDashIfNullOrUndefined(key)));
            },
        },
    ];
    const volumeBasedColumn = [
        {
            columnName: "Plan Name",
            arrows: false,
            key: "schemeName",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Start Date",
            arrows: false,
            key: "startDate",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "End Date",
            arrows: false,
            key: "endDate",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Subscription Fees(Rs)",
            arrows: false,
            key: "chequeAmt",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Allowed Volume",
            arrows: false,
            key: "allowed_Vol",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Consumed Volume",
            arrows: false,
            key: "consumed_Vol",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Balance Volume",
            arrows: false,
            key: "balance_Vol",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Plan Status",
            arrows: false,
            key: "status",
            tdCustomFunction: (key) => {
                return (React.createElement("span", { className: "text-capitalize txt-orange-light", "data-attr": key }, addDashIfNullOrUndefined(key)));
            },
        },
    ];
    return (React.createElement(React.Fragment, null, device.isDesktop ? (subsFeeCommData.loader ? (React.createElement(Common_Shimmer, null)) : subsFeeCommData.errorData.isOpen ? (React.createElement(ErrorNotification, { error: subsFeeCommData.errorData.error, isOpen: subsFeeCommData.errorData.isOpen, displayType: ErrorDisplayType.INSECTION })) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "displayFlex justify-end mgt-20 gap-10" },
            React.createElement("div", { className: "common-download" },
                React.createElement("button", { className: `download-btn ${(props === null || props === void 0 ? void 0 : props.disableDownload()) ? "cursor_not_allowed" : ""}`, onClick: () => {
                        props.setShowDownloadPopup(true);
                    }, disabled: props === null || props === void 0 ? void 0 : props.disableDownload() },
                    React.createElement("img", { src: download }),
                    "Download"))),
        React.createElement(GenericTable, { columns: props.type === SubscriptionFeeSubType.RATE
                ? rateBasedColumn
                : volumeBasedColumn, data: props.type === SubscriptionFeeSubType.RATE
                ? !!((_a = SubsFeedata === null || SubsFeedata === void 0 ? void 0 : SubsFeedata.subscriptionFee) === null || _a === void 0 ? void 0 : _a.rateBased)
                    ? (_b = SubsFeedata === null || SubsFeedata === void 0 ? void 0 : SubsFeedata.subscriptionFee) === null || _b === void 0 ? void 0 : _b.rateBased
                    : []
                : !!((_c = SubsFeedata === null || SubsFeedata === void 0 ? void 0 : SubsFeedata.subscriptionFee) === null || _c === void 0 ? void 0 : _c.volBased)
                    ? (_d = SubsFeedata === null || SubsFeedata === void 0 ? void 0 : SubsFeedata.subscriptionFee) === null || _d === void 0 ? void 0 : _d.volBased
                    : [], parentClassName: "common-table-border table", rowClassName: "subscriptionClassNames" }),
        subsFeeCommData.message.show && (React.createElement("div", { className: "aligncenteritem new-paths-errormsg" },
            React.createElement(Errormsg, { customMsg: React.createElement("div", { className: "DMSan_14_700 txt-midnight-blue lh-140" },
                    "No results found!",
                    React.createElement("div", { className: "DMSanN_14_400 txt_secondary-gray" }, "Try searching for something else")), paths: threePaths, icon: subsFeeCommData.message.icon }))),
        React.createElement(SubscriptionPopup, { subscriptionPopupShow: subscriptionPopupShow, setSubscriptionPopupShow: setSubscriptionPopupShow, schemeRefNo: selectedSubscriptionRate === null || selectedSubscriptionRate === void 0 ? void 0 : selectedSubscriptionRate.schemeRefNo, schemeName: selectedSubscriptionRate === null || selectedSubscriptionRate === void 0 ? void 0 : selectedSubscriptionRate.schemeName })))) : (React.createElement(SubscriptionMobileTable, { type: props.type, data: props.type === SubscriptionFeeSubType.RATE
            ? SubsFeedata.subscriptionFee.rateBased
            : SubsFeedata.subscriptionFee.volBased, message: subsFeeCommData.message, loader: subsFeeCommData.loader, errorData: subsFeeCommData.errorData, subscriptionPopupShow: subscriptionPopupShow, setSubscriptionPopupShow: setSubscriptionPopupShow, selectedSubscriptionRate: selectedSubscriptionRate, setSelectedSubscriptionRate: setSelectedSubscriptionRate }))));
};
export default SubscriptionTabData;
